import React, { useCallback } from 'react';
import { Input, InputLabel, InputProps } from '@material-ui/core';

import { inputStyles } from './styles';
import { useId } from '../../../../hooks';

type Props = Omit<InputProps, 'classes' | 'onChange'> & {
  type?: 'text' | 'textarea';
  label: React.ReactNode;
  value: string;
  onChange: (value: string) => void;
};

const InputComponent = ({ label, value, onChange, type = 'text', ...props }: Props):React.ReactComponentElement<'input'> => {
  const classes = inputStyles();
  const inputId = useId();

  const extras: Partial<InputProps> = type === 'textarea' ? {
    multiline: true,
    rowsMax: 10,
  } : {
    type,
  };

  const onChangeHandler = useCallback((event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    (async () => onChange(event.target.value))();
  }, [onChange]);

  return (
    <>
      <InputLabel
        htmlFor={inputId}
        classes={{
          root: classes.labelRoot,
          focused: classes.focused,
        }}
      >
        {label}
      </InputLabel>
      <Input
        value={value}
        onChange={onChangeHandler}
        id={inputId}
        fullWidth
        {...extras}
        {...props}
        classes={{
          input: classes.input,
          underline: classes.inputUnderline,
          focused: classes.focused,
          disabled: classes.disabled,
        }}
      />
    </>
  );
};

export default InputComponent;
